import { Injectable } from '@angular/core';
import { EsriObjectData } from '../providers/esri-object-data';
import { AppData } from '../providers/app-data';
import { SimpleLineSymbol} from '../interfaces';

@Injectable()
export class SymbolData {

	esriObjects:any;

    constructor(private esriObjectData: EsriObjectData, public appData: AppData) {
	}

	getHexColor(color:any) {
		//ensure it is not an array first before a check if it is an object since array will classify
		//as an object
		if (!Array.isArray(color) && typeof color === 'object') {
			color = [color.r, color.g, color.b];
		}
        var rgb =color[2] | (color[1] << 8) | (color[0] << 16);
        return '#' + (0x1000000 + rgb).toString(16).slice(1)
  	}

	getGraphicFromGeometry(geometry, color) {
		this.esriObjects = this.esriObjectData.EsriObjects;
		let symbol = this.getSymbolFromGeometry(geometry.type, color);
        return new this.esriObjects.Graphic(geometry, symbol);
	}

	getPointGraphic(point, color, size, borderColor?, borderWidth?) {
		this.esriObjects = this.esriObjectData.EsriObjects;
		var pointSymbol = this.getPointSymbol(color, size, borderColor, borderWidth);
		return new this.esriObjects.Graphic(point, pointSymbol);
	}

	getSymbolFromGeometry(geometryType, color) {
		this.esriObjects = this.esriObjectData.EsriObjects;
		var symbol = null;
        if (geometryType === 'point' || geometryType === 'multipoint') {
            return this.getPointSymbol(color, 14, 5)
        }
        else if (geometryType === 'polyline') {
			let width = 3;
            return this.getLineSymbol(color, width);
        }
		return symbol;
	}

	getSymbolDefinitionFromGeometry(geometryType, color): any {
		if (geometryType === 'point' || geometryType === 'multipoint') {
            return this.getSimpleMarkerDefinition(color, 12, color, 1);
        } else if (geometryType === 'polyline') {
			return this.getSimpleLineDefinition(color, 5);
		}
	}

	getSimpleLineDefinition(color: Array<number>, width: number) : SimpleLineSymbol {
		return {
			'color': color,
			'style': 'solid',
			'type': 'simple-line',
			'width': width
		}
	}

	getSimpleMarkerDefinition(color, size, borderColor?, borderWidth?) {
		return {
			'color': color,
			'type': 'simple-marker',
			'size': size,
			'outline': this.getSimpleLineDefinition(borderColor, borderWidth)
		}
	}

	getPointSymbol(color, size, borderColor?, borderWidth?) {
		if (!borderWidth){
			borderWidth = 0;
		}
		if (!borderColor)	{
			borderColor = color;
		}
		this.esriObjects = this.esriObjectData.EsriObjects;
		let pointDefinition = this.getSimpleMarkerDefinition(color, size, borderColor, borderWidth);
		return new this.esriObjects.SimpleMarkerSymbol(pointDefinition);
	}

	getLineSymbol(color, width) {
		let lineDefinition = this.getSimpleLineDefinition(color,width);
		return new this.esriObjects.SimpleLineSymbol(lineDefinition);
	}

}


// WEBPACK FOOTER //
// ./src/providers/symbol-data.ts